import { render } from "./Page-Assembly.vue?vue&type=template&id=5cf62e18&scoped=true"
import script from "./Page-Assembly.vue?vue&type=script&lang=js"
export * from "./Page-Assembly.vue?vue&type=script&lang=js"

import "./Page-Assembly.vue?vue&type=style&index=0&id=5cf62e18&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cf62e18"]])

export default __exports__